import { config } from './config';
import { USER_ROLES } from './constants';
import { UserRole } from './types';

let wasInitialised = false;

export const ensureSdkReady = () => {
  const init = () => {
    if (!wasInitialised) {
      wasInitialised = true;
      // @ts-expect-error no types
      window.FB.init({
        appId: config.FACEBOOK_APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v13.0',
      });
    }
  };

  // @ts-expect-error not typed
  if (window.FB) {
    init();
    return Promise.resolve();
  }

  return new Promise<void>((resolve) => {
    const interval = setInterval(() => {
      // @ts-expect-error not typed
      if (window.FB) {
        clearInterval(interval);
        init();
        resolve();
      }
    }, 100);
  });
};

export const rolePermission = {
  auth: (role: UserRole) =>
    [USER_ROLES.Admin, USER_ROLES.Moderator].includes(role),
  usersPage: (role: UserRole) => role === USER_ROLES.Admin,
  eventsEditDelete: (role: UserRole) => role === USER_ROLES.Admin,
};

export const addHoursToDate = (numOfHours: number, date = new Date()) => {
  date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
  return date;
};
